import { ViewModelFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import {
  createFilterViewModels,
  FilterViewModel,
} from '../filterViewModel/filterViewModel';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import { CalendarState } from '../../controller';
import settingsParams from '../../settingsParams';

export type HeaderViewModel = {
  title: string;
  subtitle: string;
  isSubtitleVisible: boolean;
  filters: FilterViewModel[];
};

export function createHeaderViewModel({
  state,
  context,
}: ViewModelFactoryParams<CalendarState, CalendarContext>): HeaderViewModel {
  const { settings } = context;
  const { selectedService } = state;
  const title = selectedService.info.name;
  const filters = createFilterViewModels({ state, context });
  const isSubtitleVisible = settings.get(
    settingsParams.headerSubtitleVisibility,
  );
  const subtitle = settings.get(
    settingsParams.headerSubtitleShouldBeServiceTagline,
  )
    ? selectedService.info.tagline
    : settings.get(settingsParams.headerSubtitleText);

  return {
    title,
    subtitle,
    isSubtitleVisible,
    filters,
  };
}
